module.exports = __webpack_public_path__ + "static/media/Sass_Logo.64f68b22.png";